(() => {
 const setup = () => {
  document.querySelectorAll('[data-ks-restock]').forEach(form => {
   if(form.dataset.ready)return;
   form.dataset.ready='true';
   const product=form.closest('.ks-attachment-head')?.querySelector('ks-product');
   product?.addEventListener('variant:change',event=>{
    form.hidden=event.detail.variant.available;
    form.querySelector('[name="variant_id"]').value=event.detail.variant.id;
   });
   form.addEventListener('submit',async event=>{
    event.preventDefault();
    if(!form.reportValidity())return;
    const button=form.querySelector('[type="submit"]');
    if(button.disabled)return;
    button.disabled=true;form.removeAttribute('data-state');
    const payload={data:{type:'back-in-stock-subscription',attributes:{profile:{data:{type:'profile',attributes:{email:form.querySelector('[type="email"]').value.trim()}}},channels:['EMAIL']},relationships:{variant:{data:{type:'catalog-variant',id:'$shopify:::$default:::'+form.querySelector('[name="variant_id"]').value}}}}};
    try{
     const response=await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=QeupfE',{method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},body:JSON.stringify(payload)});
     if(!response.ok)throw new Error('Subscription failed');
     form.dataset.state='success';
    }catch{form.dataset.state='error';button.disabled=false;}
   });
  });
  document.querySelectorAll('[data-ks-offer-end]').forEach(offer=>{
   if(offer.dataset.ready)return;
   offer.dataset.ready='true';
   const tick=()=>{
    const seconds=Math.max(0,Math.floor((Date.parse(offer.dataset.ksOfferEnd)-Date.now())/1000));
    offer.hidden=seconds===0;
    const values={days:Math.floor(seconds/86400),hours:Math.floor(seconds/3600)%24,minutes:Math.floor(seconds/60)%60,seconds:seconds%60};
    for(const [unit,value] of Object.entries(values))offer.querySelector('[data-ks-time="'+unit+'"]').textContent=String(value).padStart(2,'0');
   };
   tick();const timer=setInterval(()=>{if(!offer.isConnected||offer.hidden){clearInterval(timer);return;}tick();},1000);
  });
  document.querySelectorAll('.ks-attachment-legacy-preorder').forEach(note=>{
   const timer=note.querySelector('#savp-countdown');if(timer)timer.hidden=true;
   const expired=note.querySelector('#savp-offer-line');if(expired)expired.hidden=true;
  });
  document.querySelectorAll('.ks-attachment-story a[href="#"],.ks-attachment-story a[href="#lm360-top"],.ks-attachment-story a[href="#alc-product"]').forEach(link=>{
   if(link.dataset.ksReady)return;link.dataset.ksReady='true';
   if(/close|cta|btn|button/.test(link.className)||link.hash.length>1)link.addEventListener('click',event=>{event.preventDefault();document.querySelector('.ks-attachment-head')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});
  });
  document.querySelectorAll('.ks-attachment-story .mbc-act').forEach(button=>{
   if(button.dataset.ksReady)return;button.dataset.ksReady='true';
   button.setAttribute('aria-expanded',String(button.parentElement.classList.contains('open')));
   button.addEventListener('click',()=>button.setAttribute('aria-expanded',String(button.parentElement.classList.toggle('open'))));
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
 document.addEventListener('shopify:section:load',setup);
})();
